import { ID } from 'libs/id'
import { sanitizeClassName } from 'presentation/libs/sanitizeClassName'

export const createCompsEntryElementId = (id: ID) =>
  `comps-entry-${sanitizeClassName(id)}`
